import { useTranslation } from "react-i18next";
import styles from "./ClientAccount.module.css";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import rightArrow from "../../assets/SetaDireita.svg";
import Footer from "../../components/footer/Footer";
import MinhaContaPedido from "../../components/MinhaContaPedidos/MinhaContaPedidos";
import ClientCardsList from "../../components/ClientCardsList";
import ClientListAddress from "../../components/ClientListAddress";
import EditarEndereco from "../../components/EditarEndereco/EditarEndereco";
import Favoritos from "../../components/Favoritos/Favoritos";
import SideBar from "../../components/SideBar/SideBar";
import AlterarPerfil from "../../components/AlterarPerfil/AlterarPerfil";
import AdicionarEndereco from "../../components/AddEndereco/AdicionarEndereco.tsx";
import PerfilCliente from "../../components/PerfilCliente/PerfilCliente.tsx";
import ClientAccountChat from "../ClientAccountChat.tsx/ClientAccountChat.tsx";

const smallScreenPx = 1024

const ClientAccount = () => {
  const { content, subContent } = useParams();
  const { t } = useTranslation();

  const activeSubContent =
    subContent && (subContent === "edit" || subContent === "add");

  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    window?.innerWidth < smallScreenPx
  );

  const handleWindowSizeChange = () =>
    setIsSmallScreen(window?.innerWidth < smallScreenPx);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);

    return () => window.removeEventListener("resize", handleWindowSizeChange);
  }, []);

  if(content === "profile" && subContent === "edit"){
    console.log("entrou no edit")
  }

  return (
    <>
      <Header
        boxShadow
        mobileMenuActiveState={isMobileMenuVisible}
        toggleMobileMenu={setIsMobileMenuVisible}
        isSmallScreen={isSmallScreen}
      />
      <main className={styles.mainContainer}>
        <section className={styles.sectionContainer}>
          {!activeSubContent ? (
            <div className={styles.breadCrumbs}>
              <span>{t("accountMenu.myAccount")}</span>
              <img src={rightArrow} />
              <span className={styles.optionSelected}>
                {t(`accountMenu.${content}`)}
              </span>
            </div>
          ) : (
            <div className={styles.breadCrumbs}>
              <span>{t("accountMenu.myAccount")}</span>
              <img src={rightArrow} />
              <span>{t(`accountMenu.${content}`)}</span>
              <img src={rightArrow} />
              <span className={styles.optionSelected}>
                {subContent === "add" && t(`accountMenu.addProduct`)}
                {content === "addresses" &&
                  subContent === "edit" &&
                  t(`accountMenu.editAddress`)}
                {content === "cards" &&
                  subContent === "edit" &&
                  t(`accountMenu.editCard`)}
                {content === "profile" &&
                  subContent === "edit" &&
                  t("alterarPerfil.changeProfile")}
              </span>
            </div>
          )}

          {content === "profile" && !subContent && <PerfilCliente />}
          {content === "profile" && subContent === "edit" && <AlterarPerfil />}
          {content === "favorites" && <Favoritos />}
          {content === "orders" && <MinhaContaPedido />}
          {content === "cards" && subContent === "list" && <ClientCardsList />}
          {/* {content === "cards" && subContent === "edit" && <EditarCartao />} */}
          {content === "chat" && <ClientAccountChat />}
          {content === "addresses" && subContent === "list" && (
            <ClientListAddress />
          )}
          {content === "addresses" && subContent === "edit" && (
            <EditarEndereco />
          )}
          {content === "addresses" && subContent === "add" && (
            <AdicionarEndereco />
          )}
        </section>
        {(!isSmallScreen || (isSmallScreen && isMobileMenuVisible)) && (
          <aside className={styles.asideContainer}>
            <SideBar isSmallScreen={isSmallScreen} closeMobileMenu={() => setIsMobileMenuVisible(false)} />
          </aside>
        )}
      </main>
      {!isSmallScreen && <Footer />}
    </>
  );
};

export default ClientAccount;
